import fetch from 'whatwg-fetch'
import "semantic-ui-css/semantic.min.css"
import "./src/styles/typography.scss"
import "./src/styles/global.scss"
